<template>
  <SettingsSection>
    <SettingsSectionHeader>
      <SettingsSectionTitle>Your Subscription</SettingsSectionTitle>
      <Button
        slot="btn"
        variant="outline"
        size="small"
        to="/account/change-plan"
        >Change Plan</Button
      >
    </SettingsSectionHeader>

    <SubscriptionDetailsCard
      v-bind="subscriptionCardProps"
      :number-of-users="numberOfUsers"
      :number-of-profiles="numberOfProfiles"
    />

    <p
      v-for="org in paidOrganizations"
      :key="org._id.$oid"
      class="billing-note"
    >
      You also have an active subscription on
      <strong>{{ org.name }}</strong
      >.
      <router-link :to="`/organization/${org._id.$oid}/billing/change-plan`"
        >Manage organization billing &rarr;</router-link
      >
    </p>
  </SettingsSection>
</template>

<script>
import { Button } from '@campsite-bio/component-lib';
import { computed, onMounted } from 'vue';

import {
  SettingsSection,
  SettingsSectionTitle,
  SettingsSectionHeader,
} from '../settings-section';
import SubscriptionDetailsCard from '../billing/subscription-details-card';
import { useCurrentUserSubscription, useStore } from '@/compositions';
import { reportError } from '@/utils/report-error';

export default {
  components: {
    Button,
    SettingsSection,
    SettingsSectionTitle,
    SettingsSectionHeader,
    SubscriptionDetailsCard,
  },

  setup() {
    const store = useStore();
    const { subscriptionCardProps, numberOfProfiles, numberOfUsers } =
      useCurrentUserSubscription();

    const organizations = computed(() => {
      return store.getters['organizations/getField']('organizations');
    });

    const paidOrganizations = computed(() => {
      return organizations.value.filter((org) => org.plan !== 'free');
    });

    onMounted(async () => {
      try {
        await store.dispatch('organizations/all');
      } catch (e) {
        reportError(e);
      }
    });

    return {
      subscriptionCardProps,
      numberOfProfiles,
      numberOfUsers,
      paidOrganizations,
    };
  },
};
</script>

<style lang="scss" scoped>
.billing-note {
  margin-top: 0.75rem;
  margin-bottom: 0;
  font-size: 0.8125rem;
  color: var(--g-color-gray-500);

  a {
    color: var(--g-color-primary);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
